module.exports = __webpack_public_path__ + "img/hj.0db8fae8.png";